import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const brandLogos = ['brand-1.png', 'brand-2.png', 'brand-3.png', 'brand-4.png', 'brand-5.png', 'brand-8.png', 'brand-7.png'];

const Demo6Brands2 = () => {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]
    };

    return (
        <div id="brands-2" className="wide-70 brands-section division bg-brands-shade">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <div className="brands-title text-center">
                            <p className="p-xl">Trusted by translation teams worldwide</p>
                        </div>
                    </div>
                </div>
                <div className="brands-2-wrapper">
                    <Slider {...settings}>
                        {brandLogos.map((logo) => (
                            <div className="brand-logo" key={logo}>
                                <img className="img-fluid" src={`/images/demo6/${logo}`} alt="brand-logo" />
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </div>
    );
};

export default Demo6Brands2;
